module.exports = __webpack_public_path__ + "img/f785308.png";